(function() {
    'use strict';
    angular
        .module('mVtasWebApp')
        .factory('Modelosdeimpresora', Modelosdeimpresora);

    Modelosdeimpresora.$inject = ['$resource'];

    function Modelosdeimpresora ($resource) {
        var resourceUrl =  'api/modelosdeimpresoras/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
